import { h } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';
import messenger from '../messenger';
import client from '../lib/api';
import { isAccelPayMessage, getAddress } from '../lib/utils';
import { useAvailability } from '../lib/hooks';

const DataFetcher = ({
  brandId,
  variantIds = [],
  doordashVariantIds = [],
  collectionIds = [],
  sentryTransaction,
  apiEnv,
  hasLocalDelivery = false,
  currency = 'USD',
}: any) => {
  const api = new client(apiEnv);
  const [address, setAddress] = useState(getAddress());

  const {
    standardAvailability,
    doordashAvailability,
    gopuffAvailability,
    collections,
    loading,
    error,
  } = useAvailability({
    variantIds,
    doordashVariantIds,
    collectionIds,
    brandId,
    retailerTypes: ['standard', 'merch_only', 'self_fulfiller'],
    apiEnv,
    currency,
    hasLocalDelivery,
    address,
  });

  useEffect(() => {
    if (standardAvailability && typeof standardAvailability === 'object') {
      messenger.variantData(window, '*', standardAvailability);
    }
  }, [standardAvailability]);

  useEffect(() => {
    if (doordashAvailability && typeof doordashAvailability === 'object') {
      messenger.doordashVariantData(window, '*', doordashAvailability);
    }
  }, [doordashAvailability]);

  useEffect(() => {
    if (gopuffAvailability && typeof gopuffAvailability === 'object') {
      messenger.gopuffVariantData(window, '*', gopuffAvailability);
    }
  }, [gopuffAvailability]);

  useEffect(() => {
    if (Object.keys(collections).length > 0) {
      messenger.collectionData(window, '*', collections);
    }
  }, [collections]);

  useEffect(() => {
    const handleMessage = e => {
      if (!isAccelPayMessage(e)) {
        return;
      }

      const { action, value } = e.data;
      if (action === 'bc-add-address') {
        // Update the address state with the value from the message
        setAddress(value.address);
      }
    };

    window.addEventListener('message', handleMessage, false);
    window.apbrand?.listeners?.push(handleMessage);
  }, []);

  return null;
};

export default DataFetcher;
